import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Provider } from "react-redux";
import { store } from "./redux/store";
const theme = createTheme({
 palette: {
  primary: {
   main: "#000D6B",
  },
  secondary: {
   main: "#dc004e",
  },
 },
});
console.log("store:", store.getState());
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 <Provider store={store}>
  <BrowserRouter>
   <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
   </ThemeProvider>
  </BrowserRouter>
 </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
